/**
 * UUID stables pour INIT_* (sync Supabase + isUuid). Pool unique — ne pas réordonner sans migration.
 */

const U = [
  "a2fe45fb-a39e-4cc9-bf29-846e8aee8cb5",
  "97b61c9b-7b7b-433c-b8b4-1d3406efabbc",
  "ca31dfaf-f924-48e2-92fc-4083595b5e28",
  "15dfd518-f574-458e-a599-fd16f5c21ff5",
  "08ad838d-e498-4b44-9e97-6eec4ac1b220",
  "88cdf8b1-04bc-42d2-a897-2bff3183342b",
  "8314cf09-8ec9-4299-bf03-da7e8b1b1b1e",
  "fe2a63bc-b266-47ff-b81b-1998f3cd047b",
  "ab666aab-dce2-4927-95b9-ee9c948912ce",
  "291c3b2a-7254-49bf-a711-e7360a9db1d4",
  "6bbeb5d1-e322-417b-ad01-1637d9311615",
  "5b2d7897-2ae2-4bb7-94c9-c80a99313f07",
  "cfdf63c7-997f-4996-9268-b90b9c183ba9",
  "ddf3f0cf-946c-47e3-8b3c-698e7cf6dde0",
  "3144be29-5ef4-4fe6-8bd8-fcd40894c2e1",
  "3f09f2b6-a4ab-4f90-9b28-f0999dc36259",
  "c6223a84-6f2e-40a8-8821-24422db45d69",
  "cf0cd9c8-c5ed-4ab2-aaa3-e1e132bdd9a8",
  "9fa0d6a0-eefa-42cb-9779-778fdea635a7",
  "853cff4d-606a-461e-b695-d22da67717aa",
  "44e3e832-b8a4-4286-8aca-8f60bc5c9ae2",
  "dde4f150-2caa-492b-a99b-0bab434c0376",
  "2fafeddc-ff50-40ff-ab0e-dec275e37615",
  "81d7bcba-2eef-4402-86b2-c2b63e5fc360",
  "8d20de39-17a7-449e-8afa-c75dbdd4acc7",
  "b7a8d20b-5669-4748-855d-4f756ea037b4",
  "1f90a1dd-3433-4339-a690-36b48daa6c1a",
  "ed06cd6d-bf3b-4191-839f-b30625036f51",
  "0a6414e3-282c-4095-9963-5174dd2c4696",
  "69ea7044-6935-47f5-a5eb-31014958d751",
  "69e18904-718e-4c6b-a6ab-509c703cc8c7",
  "6fad88de-3ed7-4443-97be-b9ed3fc865e3",
  "0c00cdcd-d415-42a7-89a3-ed8425cf8a4e",
  "9c872abf-38f6-4cc9-b5e1-6ee95a50c956",
  "7a842d5f-eece-4e78-980e-7f2401d4d9f4",
  "ea96c70c-e3d6-4d8f-b910-81fa02e774f3",
  "a846928e-c77b-4110-aa29-e923390bdfd5",
  "33267348-e55b-4380-a486-977f522a9e1c",
  "c103ba57-3ca9-4936-aff3-9f738f348de2",
  "24ef24a2-8a3b-4e53-9437-a619d56ea762",
  "958b97a4-0e45-4424-8b72-6a51d090d858",
  "1d65963a-4a69-4aec-b9b9-ed2c9acbea28",
  "47adcbe1-a080-4dec-9425-5e1b6c594745",
  "076e7148-ff47-48d1-b733-9b2600af8965",
  "df33f1a7-f5b5-44aa-ae07-10a4828d3d25",
  "c6bdb9c8-8431-46c5-96e9-727fddb5114d",
  "5c8880a3-14e8-446f-bdb0-d5f39cdefcb0",
  "880f9180-bec3-482f-a4f3-9dbb070e550e",
  "79171586-a271-493c-a251-f8043d0a428d",
  "a0e034f4-9dfa-4dd5-8f23-b5d4522276b4",
  "2ed63f6c-99b1-4a2b-91f2-6f7c8635271f",
  "a2129590-f351-4454-bdb3-b6cd913c3386",
  "ea1c7857-b074-4acf-ab6b-bca61052a2cd",
  "c9f42f19-512f-45bd-bc2f-2b212313eb2b",
  "1494ccdf-b9b6-4b2e-8b01-bb8468d49237",
  "d3a4f56e-5838-4098-902d-8b4b591a523a",
  "2cf3e98d-c70a-4f39-9bc7-86e8ddf06c68",
  "3ea8549b-e0b7-46f9-b79c-0096eca2035a",
  "0e6f09cb-8bf2-4b83-9f39-4df420320627",
  "e4b545ed-ee22-4aff-b490-dea2c276964d",
  "3132902d-e789-4df4-abbb-c1a3e919cc7c",
  "4f73a973-788f-4820-b833-4144134ff376",
  "93f28125-db2b-4ea7-97ff-7883a1384b3c",
  "bb3e8808-db20-49dc-b32e-280a7ea98768",
  "76e76b22-cccb-4178-b52c-097aa1383478",
  "124d1383-ae96-434e-a64c-727656399401",
  "5e544a09-27f0-4c53-9251-81a5107b1fda",
  "103a6b65-f061-4db9-bbf1-fac7a41edaa8",
  "2c2399b6-0a93-42de-83fd-b1f165a9315f",
  "54985c23-45f9-49c1-97a6-97738fcb5855",
  "45232de1-c42b-4f05-a745-0012b5ab1ffc",
  "4f4d3769-7689-498d-ae6b-4d6e3d99cd76",
  "7df73a7d-b223-4f20-b821-d70ce5bc3930",
  "b6b37098-d77b-4245-94ff-baf622e55a77",
  "e3a2ae77-fbc1-45c7-9616-b61698f18c05",
  "dad8e44e-88b0-4d0f-8462-8cfec4d7792e",
  "e3261b38-52f4-4e1f-8784-1e4827dc7dc5",
  "8c4f7ce2-b70f-482e-931d-43361120c093",
  "b0ec35b8-b18f-4588-81c1-92f6911b6daa",
  "d118d1c4-db07-42c5-b3f9-ec24f7ce3401",
  "1ed07ee0-cad7-4f63-8e3c-f5a848716d7f",
  "6ebc15d7-0b42-42af-81fc-41e0cc09ff95",
  "63c53bc1-e773-4cd2-8f5b-eb8107b5ca8b",
  "c849e762-1dc3-42cf-8665-7e2b5c6f31bc",
  "7ca2fe14-2b44-4674-adaa-19035b486a75",
  "a63e7858-5298-4284-af30-d7165faa409d",
  "5041ee1d-d330-420f-96f1-13cb8f9d5fff",
  "2442ca05-5178-48d1-bb9e-65bce86cd6fd",
  "b832cc84-bd98-4dcb-b397-4327a19d9d09",
  "fcbdaf47-985e-4b89-98d2-9a56f3832bb9",
  "d690593e-411a-4a7d-9ca0-d107389bb144",
  "2aeba0c1-ff9c-4174-a2ef-205e687ddc98",
  "9d6b2e79-469e-449c-90d3-ce5d1ad0c5cc",
  "1d193e27-c921-4303-8b5d-cc01f284107f",
  "2bfacdbc-686a-44d6-b638-bb73250ddbfe",
  "159c1bfe-7c3f-4f46-837e-eec08794cdc5",
  "2959801b-7dad-45ee-b163-496e480b7e7e",
  "8cdedbb8-56d3-4628-accd-ad36534fa144",
  "08ebe0f2-8bc8-4c31-a8f4-fa9fdb3f798b",
  "854fe82c-a4e6-433b-aaad-166d6404e208",
];

const S = U.slice(11, 43);
const M = U.slice(57, 85);
const P = U.slice(85, 90);

export const DEMO_CLIENT_IDS = U.slice(0, 8);
export const DEMO_RG_SOPHIE = U[8];
export const DEMO_RG_MARIE = U[9];
export const DEMO_RG_THOMAS = U[10];

export const DEMO_SESSION_IDS = {
  sophie1: S[0],
  sophie2: S[1],
  sophie3: S[2],
  sophieCxl: S[3],
  thomas1: S[4],
  thomas2: S[5],
  thomas3: S[6],
  thomas4: S[7],
  thomas5: S[8],
  thomas6: S[9],
  marie1: S[10],
  marie2: S[11],
  marie3: S[12],
  marie4: S[13],
  karim1: S[14],
  karim2: S[15],
  karim3: S[16],
  karim4: S[17],
  karim5: S[18],
  lucas1: S[19],
  lucas2: S[20],
  lucas3: S[21],
  lucas4: S[22],
  julie1: S[23],
  julie2: S[24],
  julie3: S[25],
  antoineFeb: S[26],
  antoineM1: S[27],
  antoineM2: S[28],
  antoineM3: S[29],
  paul1: S[30],
  paul2: S[31],
  /** Séance planifiée (builder) — démo Sophie (pool U[90–99] hors slices) */
  sophiePlanned: U[99],
};

const E = U.slice(43, 52);
export const DEMO_CAL_EVENT_IDS = {
  e1: E[0],
  e2: E[1],
  e3: E[2],
  e4: E[3],
  e5: E[4],
  e6: E[5],
  e7: E[6],
  e8: E[7],
  e9: E[8],
  finMarSophieCxl: U[52],
  finMarMarieNs: U[53],
  finFebLucas1: U[54],
  finFebPaul1: U[55],
  finFebPaul2: U[56],
};

/** 28 séances done mars — ordre pushDone dans _demoFinanceMarchCalendar */
export const DEMO_FIN_MARCH_DONE_IDS = M;

/** 5 événements plan démo rolling (e-demoplan-*) */
export const DEMO_DEMOPLAN_EVENT_IDS = P;

/** Offres INIT_PRODUCTS — UUID sync table `products` */
export const DEMO_PRODUCT_IDS = {
  session: "2ec73043-56ae-4a3f-8479-62a6f3e4cfc3",
  pack: "3672099e-93dd-490c-b051-d1b7b327c476",
  subscription: "91cbed33-cefc-4a3f-8a4a-70e79f3108d3",
  programme: "4bc1a9db-df97-4553-a388-cc5794d2328a",
};
